export const COLOR_MAP = {
  Pink: [ 'Medium Violet Red',
    'Deep Pink',
    'Pale Violet Red',
    'Hot Pink',
    'Light Pink',
    'Pink' ],
  Red: [ 'Dark Red',
    'Red',
    'Firebrick',
    'Crimson',
    'Indian Red',
    'Light Coral',
    'Salmon',
    'Dark Salmon',
    'Light Salmon' ],
  Orange: [ 'Orange Red',
    'Tomato',
    'Dark Orange',
    'Coral',
    'Orange' ],
  Yellow: [ 'Dark Khaki',
    'Gold',
    'Khaki',
    'Peach Puff',
    'Yellow',
    'Pale Goldenrod',
    'Moccasin',
    'Papaya Whip',
    'Light Goldenrod Yellow',
    'Lemon Chiffon',
    'Light Yellow' ],
  Brown: [ 'Maroon',
    'Brown',
    'Saddle Brown',
    'Sienna',
    'Chocolate',
    'Dark Goldenrod',
    'Peru',
    'Rosy Brown',
    'Goldenrod',
    'Sandy Brown',
    'Tan',
    'Burlywood',
    'Wheat',
    'Navajo White',
    'Bisque',
    'Blanched Almond',
    'Cornsilk' ],
  Green: [ 'Dark Green',
    'Green',
    'Dark Olive Green',
    'Forest Green',
    'Sea Green',
    'Olive',
    'Olive Drab',
    'Medium Sea Green',
    'Lime Green',
    'Lime',
    'Spring Green',
    'Medium Spring Green',
    'Dark Sea Green',
    'Medium Aquamarine',
    'Yellow Green',
    'Lawn Green',
    'Chartreuse',
    'Light Green',
    'Green Yellow',
    'Pale Green' ],
  Cyan: [ 'Teal',
    'Dark Cyan',
    'Light Sea Green',
    'Cadet Blue',
    'Dark Turquoise',
    'Medium Turquoise',
    'Turquoise',
    'Aqua',
    'Cyan',
    'Aquamarine',
    'Pale Turquoise',
    'Light Cyan' ],
  Blue: [ 'Navy',
    'Dark Blue',
    'Medium Blue',
    'Blue',
    'Midnight Blue',
    'Royal Blue',
    'Steel Blue',
    'Dodger Blue',
    'Deep SkyBlue',
    'Cornflower Blue',
    'Sky Blue',
    'Light Sky Blue',
    'Light Steel Blue',
    'Light Blue',
    'Powder Blue' ],
  Purple: [ 'Indigo',
    'Purple',
    'Dark Magenta',
    'Dark Violet',
    'Dark Slate Blue',
    'Blue Violet',
    'Dark Orchid',
    'Fuchsia',
    'Magenta',
    'Slate Blue',
    'Medium Slate Blue',
    'Medium Orchid',
    'Medium Purple',
    'Orchid',
    'Violet',
    'Plum',
    'Thistle',
    'Lavender' ],
  White: [ 'Misty Rose',
    'Antique White',
    'Linen',
    'Beige',
    'White Smoke',
    'Lavender Blush',
    'OldLace',
    'Alice Blue',
    'Seashell',
    'Ghost White',
    'Honeydew',
    'Floral White',
    'Azure',
    'Mint Cream',
    'Snow',
    'Ivory',
    'White' ],
  Grey: [ 'Black',
    'Dark Slate Grey',
    'Dim Grey',
    'Slate Grey',
    'Grey',
    'Light Slate Grey',
    'Dark Grey',
    'Silver',
    'Light Grey',
    'Gainsboro' ]
};
